import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdHeartHalf } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import TabbedView from "../components/TabbedView";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_DESCRIPTION,
  STR_DISTRICT,
  STR_FIND_MATCH,
  STR_INVALID_DESCRIPTION,
  STR_INVALID_DISTRICT,
  STR_INVALID_REGION,
  STR_LATEST_ARTICLES,
  STR_MENU_ARTICLES,
  STR_MENU_STORIES,
  STR_MENU_UTILITIES,
  STR_MORE_ARTICLES,
  STR_PLEASE_UPDATE_YOUR_PERSONAL_INFO,
  STR_PLEASE_WAIT,
  STR_REGION,
  STR_SUBMIT,
  STR_SUCCESS,
  STR_TITLE_FIND_MATCH,
	STR_UPDATE_PERSONAL_INFO
} from "../Strings";
import PersonalInfoUpdateWidget from '../ones/PersonalInfoUpdateWidget';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [loading, setLoading] = useState(false);
  

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getCurrentUserData();
    setReady(true);
  }

  

  useEffect(() => {
    init();
  }, [])


  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div className="container">
      <h6 className="mSectionTitle">{STR_CHANGE_PHONE_NUMBER[appContext.language]}</h6>

      
    </div>
  )


}